/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "cygovRestApi",
            "endpoint": "https://kmgiqrd43b.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "jiraWebhookApiV1",
            "endpoint": "https://oo0bdywdma.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://a2qw7s2b4fdwvmve3n7b6nvr6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cognito_identity_pool_id": "us-east-1:6d6e065a-f77d-43a1-b377-560caded5f77",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_7eAdRgdjL",
    "aws_user_pools_web_client_id": "5l7e82jj5elrp4pp3dt5nm1jbq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "cygov-source-code-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dyw7tcw45phr3.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AiConversations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "AiMessages-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "EntityInsights-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "EntityRegulations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "RegulationInsights-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "RegulationMaster-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "cygov-storage-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER"
    ]
};


export default awsmobile;
